import { Modal, Button } from 'appkit-react';

import helpQuestion from '../../assets/images/help-question.svg';

const ReportConformationModal = ({
    setReportConformationModal,
    setFileName,
    leave,
    setLeave,
    setTab,
}) => {
    const onRemoveHanleClick = () => {
        setReportConformationModal(false);
        setFileName('');
        if (leave) {
            setTab('second');
        }
        setLeave(false);
    };
    const onCancelHandleClick = () => {
        setReportConformationModal(false);
    };
    return (
        <Modal
            className="baseline-modal-showcase true-comply-upload__report__conformation__modal"
            visible
            data-testid="report-confirmation-model"
        >
            <div className="true-comply-upload__report__conformation__modal-body">
                <img src={helpQuestion} alt="Help Icon" />
                <div className="true-comply-upload__report__conformation__modal-body-title">
                    {leave
                        ? 'Do you want to leave your changes?'
                        : 'Are you sure you want to remove this file?'}
                </div>
                <p>
                    {leave
                        ? 'Changes you made will not be saved'
                        : 'The change cannot be undone.'}
                </p>
                <div className="true-comply-upload__report__conformation__modal-body-button-group">
                    <Button
                        kind="secondary"
                        onClick={onCancelHandleClick}
                        data-testid="cancel-btn"
                    >
                        Cancel
                    </Button>
                    <Button onClick={onRemoveHanleClick} data-testid="remove-leave-btn">
                        {leave ? 'Leave' : 'Remove'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ReportConformationModal;
